<template>
    <div
        class="items-center w-full rounded-3xl p-6"
        :class="itemClasses"
    >
        <!-- Booking Title -->
        <div
            v-show="booking.status === 'confirmed'"
            class="text-room-red text-3xl"
        >
            {{ booking.event?.title ?? "Reserviert" }}
        </div>

        <!-- Available Status -->
        <div
            v-show="booking.status === 'available'"
            class="text-room-green text-3xl"
        >
            Frei
        </div>

        <!-- Time Range -->
        <div class="text-xl text-white">
            {{ extractTime(booking.start) }}
            -
            {{ extractTime(booking.end) }}
        </div>

        <!-- Booking via Logo (for available slots) -->
        <div
            v-show="booking.status === 'available'"
            class="flex items-center whitespace-nowrap"
        >
            <div class="text-white">Buchen via</div>
            <img
                class="h-4 ml-2"
                src="/files/officeefficient_weiss_rgb.png"
                alt="logo"
            />
        </div>

        <!-- Display Name (User full name or comment) -->
        <div
            v-if="booking.display_name"
            class="text-xl text-white"
        >
            {{ booking.display_name }}
        </div>
        <p v-show="booking.checked_in_at" class="text-room-green text-2xl">
            (Eingecheckt)
        </p>
    </div>
</template>

<script>
import {extractTime} from "../../utils/conferenceRoomTime";

export default {
    name: "BookingListItem",

    props: {
        booking: {
            type: Object,
            required: true,
        },
    },

    computed: {
        itemClasses() {
            return {
                'bg-gray-600': this.booking.isCurrentBooking,
                'bg-room-grey': !this.booking.isCurrentBooking,
            };
        },
    },

    methods: {
        extractTime,
    },
};
</script>

<style scoped>
/* Flexbox */
.flex {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
}
.items-center {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}

/* Text Colors */
.text-white {
    color: #ffffff;
}
.text-room-green {
    color: #22c55e;
}
.text-room-red {
    color: #ef4444;
}

/* Text Size */
.text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
}
.text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
}
.text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
}

/* Spacing */
.p-6 {
    padding: 1.5rem;
}
.ml-2 {
    margin-left: 0.5rem;
}

/* Sizing */
.w-full {
    width: 100%;
}
.h-4 {
    height: 1rem;
}

/* Background Colors */
.bg-room-grey {
    background-color: #374151;
}
.bg-gray-600 {
    background-color: #4b5563;
}

/* Border Radius */
.rounded-3xl {
    -webkit-border-radius: 1.5rem;
    -moz-border-radius: 1.5rem;
    border-radius: 1.5rem;
}

/* Whitespace */
.whitespace-nowrap {
    white-space: nowrap;
}
</style>
